<template>
    <div>
        <ValidationProvider
            tag="div"
            :rules="rules"
            :name="vid"
            :label="label || name"
            :mode="mode"
            :model-value="modelValue"
            :validate-on-mount="false"
            v-slot="{ errors }"
        >
            <b-form-group
                :label-for="name || labelText"
                :label="labelText"
                :class="{ 'compact-control': compactFormat }"
            >
                <VueDatePicker
                    :model-value="internalTime"
                    @update:model-value="onUpdate"
                    time-picker
                    :is-24="false"
                    :disabled="disabled"
                    :clearable="clearable"
                    :text-input="textInput"
                    auto-apply
                    placeholder="HH:MM"
                    :input-class-name="errors.length ? 'is-invalid' : ''"
                />
                <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
        </ValidationProvider>
    </div>
</template>

<script>
import baseInputs from '@/components/mixins/BaseInputs';
import validatedInput from '@/components/mixins/ValidatedInput';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    name: 'p-timepicker',
    mixins: [baseInputs, validatedInput],
    components: { VueDatePicker },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        compactFormat: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        // Allow typing the time directly into the field (the picker parses it),
        // in addition to using the dropdown.
        textInput: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        value() { return this.modelValue; },
        // The picker's time model is a { hours, minutes, seconds } object, but our
        // v-model is an "HH:mm" string (matching the previous <input type="time">).
        // Convert the string into the object the picker expects.
        internalTime() {
            if (this.modelValue === null || this.modelValue === undefined || this.modelValue === '') {
                return null;
            }
            const [h, m] = String(this.modelValue).split(':');
            return { hours: Number(h) || 0, minutes: Number(m) || 0, seconds: 0 };
        }
    },
    methods: {
        onUpdate(time) {
            if (!time) {
                this.handleInput(null);
                return;
            }
            const hh = String(time.hours ?? 0).padStart(2, '0');
            const mm = String(time.minutes ?? 0).padStart(2, '0');
            this.handleInput(`${hh}:${mm}`);
        }
    }
};
</script>

<style scoped>
/* Align the picker's input with the app's form-control look. The picker renders
   its own input, so target it via :deep. */
:deep(.dp__input) {
    border-radius: 0;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    min-height: calc(1.5em + 0.75rem + 2px);
}
:deep(.dp__input.is-invalid) {
    border-color: var(--bs-danger, #dc3545);
}
</style>
